export default {
  modalTitle: {
    id: 'buyback_my_sales_counteroffer_modal_name',
    defaultMessage: 'Counteroffer',
  },
  title: {
    id: 'buyback_refurbisher_view_counter_offer_title',
    defaultMessage: 'Your assessment',
  },
  close: {
    id: 'buyback_my_sales_bank_details_modal_close',
    defaultMessage: 'Close',
  },
  alternativeController: {
    id: 'alternative-controller',
    defaultMessage: 'Controller',
  },
  alternativeCurrent: {
    id: 'alternative-current',
    defaultMessage: 'Current Slide',
  },
  alternativeNext: {
    id: 'alternative-next',
    defaultMessage: 'Next',
  },
  alternativePrevious: {
    id: 'alternative-previous',
    defaultMessage: 'Previous',
  },
  commentLabel: {
    id: 'buyback_refurbisher_view_counter_offer_comment',
    defaultMessage: 'Your comment',
  },
  newPrice: {
    id: 'buyback_refurbisher_view_counter_offer_price',
    defaultMessage: 'New price',
  },
  initialPrice: {
    id: 'buyback_refurbisher_view_counter_offer_initial_price',
    defaultMessage: 'Initial price',
  },
}
